import React from 'react';
import img from '../images/Tools.jpg';
import img2 from '../images/tryska.jpg';
import img3 from '../images/Poradenstvo.jpg';
import img4 from '../images/Service.jpg';

const Services = () => {

    return (
        <div id="services" className="bg-brand-50 py-12">
            <section data-aos="zoom-in-down">
                <div className="my-4 py-4">
                    <h2 className="my-2 text-center text-3xl text-brand uppercase font-bold">Služby</h2>

                    <div className='flex justify-center'>
                        <div className='w-24 border-b-4 border-brand'></div>
                    </div>
                    <h2 className="mt-4 mx-12 text-center text-xl lg:text-2xl font-semibold text-black">Sme hlboko
                        zaviazaní k spokojnosti našich klientov.</h2>
                </div>

                <div className="px-12" data-aos="fade-down" data-aos-delay="600">
                    <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-5">

                        <div
                            className="bg-white transition-all ease-in-out duration-400  overflow-hidden text-black hover:bg-brand hover:text-white rounded-lg shadow-2xl p-3 group">
                            <div className="flex flex-col m-2 text-justify text-sm">
                                <img alt="M&rivet - Predaj náradia"
                                     className="rounded-t group-hover:scale-[1.05] transition duration-1000 ease-in-out"
                                     src={img}/>
                                <h3 className="font-semibold my-4 text-2xl text-center">Predaj náradia</h3>
                                <p className="text-md font-medium">
                                    Kvalitné náradie je základom pre úspešné dokončenie akéhokoľvek projektu. Naša firma
                                    je váš spoľahlivý partner v oblasti predaja náradia, ktoré spĺňa najvyššie štandardy
                                    kvality a spoľahlivosti.
                                </p>
                            </div>
                        </div>

                        <div
                            className="bg-white transition-all ease-in-out duration-400  overflow-hidden text-black hover:bg-brand hover:text-white rounded-lg shadow-2xl p-3 group">
                            <div className="flex flex-col m-2 text-justify text-sm">
                                <img alt="M&rivet - Rezanie vodným lúčom"
                                     className="rounded-t group-hover:scale-[1.05] transition duration-1000 ease-in-out"
                                     src={img2}/>
                                <h3 className="font-semibold my-4 text-2xl text-center">Rezanie vodným lúčom</h3>
                                <p className="text-md font-medium">
                                    Najdôležitejšou službou našej firmy je rezanie a delenie materiálu vodným lúčom.
                                </p>
                            </div>
                        </div>

                        <div
                            className="bg-white transition-all ease-in-out duration-400  overflow-hidden text-black hover:bg-brand hover:text-white rounded-lg shadow-2xl p-3 group">
                            <div className="flex flex-col m-2 text-justify text-sm">
                                <img alt="M&rivet - Poradenstvo"
                                     className="rounded-t group-hover:scale-[1.05] transition duration-1000 ease-in-out"
                                     src={img3}/>
                                <h3 className="font-semibold my-4 text-2xl text-center ">Poradenstvo</h3>
                                <p className="text-md font-medium">
                                    Poskytujeme poradenstvo v oblasti delenia materialu a pouzitia elektrickeho naradia.
                                </p>
                            </div>
                        </div>

                        <div
                            className="bg-white transition-all ease-in-out duration-400  overflow-hidden text-black hover:bg-brand hover:text-white rounded-lg shadow-2xl p-3 group">
                            <div className="flex flex-col m-2 text-justify text-sm">
                                <img alt="M&rivet - Servis náradia"
                                     className="rounded-t group-hover:scale-[1.05] transition duration-1000 ease-in-out"
                                     src={img4}/>
                                <h3 className="font-semibold my-4 text-2xl text-center ">Servis náradia</h3>
                                <p className="text-md font-medium">
                                    Poskytujeme v rámci služieb záručný a pozáručný servis elektrického náradia značiek
                                    Metabo, Makita, Bosch, Narex
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

        </div>
    )
}

export default Services;